import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import interactions from '~/components/page/Automation/v2/state/interactions';

type Params = {
  isPastePreviewEdge: boolean;
  midX: number;
  midY: number;
  edgeKey: string;
};

const usePastePreviewSync = ({
  isPastePreviewEdge,
  midX,
  midY,
  edgeKey,
}: Params) => {
  const setCurrentInteraction = useSetRecoilState(interactions);

  /**
   * Shows the preview arrow when the user is hovering over an edge when choosing a path to connect
   */
  useEffect(() => {
    if (!isPastePreviewEdge) return;

    setCurrentInteraction(prev => {
      if (prev?.type !== 'copyAction') return prev;

      return {
        ...prev,
        copyHoverPreview: {
          ...prev.copyHoverPreview,
          to: { x: midX, y: midY, edgeKey },
        },
      };
    });

    return () => {
      setCurrentInteraction(prev => {
        if (prev?.type !== 'copyAction') return prev;
        if (prev.copyHoverPreview.to?.edgeKey !== edgeKey) return prev;

        return {
          ...prev,
          copyHoverPreview: { from: null, to: null },
        };
      });
    };
  }, [edgeKey, isPastePreviewEdge, midX, midY, setCurrentInteraction]);
};

export default usePastePreviewSync;
